
//country popup

const getLicountry = document.querySelector('.flag-wrapper');
const getLicountryMob = document.querySelector('.flag-wrapper-mob');
const getPopup = document.querySelector('.country-dropdown-site-lightbox');
const popupClose = document.querySelector('.country-dropdown-popup-wrap .icon-close');
if(getLicountry){
getLicountry.addEventListener("click", function () {
   getPopup.classList.add('popup-open');
   $("body").addClass("popup");
});
popupClose.addEventListener('click', function(){
  getPopup.classList.remove("popup-open");
  $("body").removeClass("popup");
})
}
if(getLicountryMob){
    getLicountryMob.addEventListener("click", function () {
        getPopup.classList.add('popup-open');
        $("body").addClass("popup");
     });
     popupClose.addEventListener('click', function(){
       getPopup.classList.remove("popup-open");
       $("body").removeClass("popup");
     }) 
}
async function get_country_code(){
  var user_country = Cookies.get('user_country');
  if(user_country==undefined){
   return await fetch('/browsing_context_suggestions.json')
    .then(response => response.json())
    .then(data =>{
        // console.log(data)
      var user_country =data.detected_values.country.handle;
      // console.log(user_country)
      Cookies.set('user_country', user_country, {
        expires: 7
      });
      return user_country;
   });
  }
else{
  return user_country
}
}
const current_store = window.location.origin;
const continets = {
  'UK':['UK'],
  'NL':['NL','BE'],
  // 'DE':['DE','AT','LI','FL'],
  'EU':['All'],
  'US':['US','CA','GL','MX','BZ','CR','SV','GT','HN','NI','PA','AR','BO','BR','CL','CO','EC','GF','GY','PY','PE','SR','UY','VE']
}

const continets_urls = {
  'UK':'https://uk.supercilium.com',
  'NL':'https://nl.supercilium.com',
  // 'DE':'https://de.supercilium.com',
  'EU':'https://eu.supercilium.com',
  'US':'https://supercilium.com'
}
  if ($('#country-dropdown-site-popup').length){
    var visited_popup = Cookies.get('country_dropdown_popup');
     get_country_code().then((data) => {
    // console.log('Data',data); // JSON data parsed by `data.json()` call
    var country_code = data;
   
      var ans = "",found=false;
      for (const property in continets) {
      var key = property,
        val = continets[property];
        if(val.indexOf(country_code)>-1){
          ans = key;
          found=true;
          break;
        }
      }
      if(found==false){
        ans = "EU";
      }
      var default_url = continets_urls[ans];

       var index = $(`#country-dropdown option[value*="${default_url}"]`).index();
       document.getElementById("country-dropdown").selectedIndex = index;
       var selctec_val = $(`#country-dropdown option[value*="${default_url}"]`).val();
    
      $('#country-dropdown').val(selctec_val);
       $('.selected-country').text($(`#country-dropdown option[value*="${current_store}"]`).text());
      var flag = $(`#country-dropdown option[value*="${current_store}"]`).attr('flag_icon');
      //  console.log("flag:",flag)
      if(flag){
        $('.flag_icon').attr('src',flag);  
      }
     if(current_store != default_url && visited_popup == undefined){
         window.setTimeout(function() {
          getPopup.classList.add('popup-open');
          $("body").addClass("popup");
         },3000)
         Cookies.set('country_dropdown_popup', 'dismiss', { expires: 365 });  
     }
  });     
}
$('.language-option').on('change',function(){
  let $this = $(this);
 var option = $this.children('option:selected');
 language_option(option)
})
// let german = `<option value="german">German</option>
//        <option value="english">English</option>`;
let dutch = `<option value="Dutch">Dutch</option>
       <option value="english">English</option>`;
$('.select_country').on('change',function(){
  // if($('.select_country').children('option:selected').text() == 'Germany & Austria'){
  //   $('.language-option').empty();
  //    $('.language-option').append(german);
  //    $('.language-selector').show();
  //   var option = $('.language-option').children('option:selected');
  //   language_option(option)
  // }else 
  if($('.select_country').children('option:selected').text() == 'Netherlands & Belgium'){
    $('.language-option').empty();
     $('.language-option').append(dutch);
     $('.language-selector').show(); 
    var option = $('.language-option').children('option:selected');
    language_option(option)
  }
  else{
     $('.language-selector').hide();
    $('.button-eu').hide();
    $('.country_modal-btn').show();              
  }     

})
function language_option(option){
  // if(option.val() == 'german'){
  //   $('.button-eu').show();
  //   $('.button-eu').removeAttr('href');
  //   $('.button-eu').attr("href","https://de.supercilium.com");
  //   $('.country_modal-btn').hide();
  // }else 
    if(option.val() == 'Dutch'){
    $('.button-eu').show();
    $('.button-eu').removeAttr('href');
    $('.button-eu').attr("href","https://nl.supercilium.com");
    $('.country_modal-btn').hide();
  }else if(option.val() == 'english'){
    $('.button-eu').show();
    $('.button-eu').removeAttr('href');
    $('.button-eu').attr("href","https://eu.supercilium.com");
    $('.country_modal-btn').hide();             
  }
  else{
    $('.button-eu').hide();
    $('.country_modal-btn').show();             
  }
}
$(document).on('click',".country_modal-btn",function(){
  window.location = $("#country-dropdown").val(); 
});